export default __webpack_public_path__ + "static/media/GameJem.424e65f0.jpg";